import { render, staticRenderFns } from "./FacebookCreatives.vue?vue&type=template&id=2a89b168&lang=pug"
import script from "./FacebookCreatives.js?vue&type=script&lang=js&external"
export * from "./FacebookCreatives.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports